import PublicDeleteAccountPage from "@/pages/delete-account/public-delete-account-page";
// Temporarily disabled pending a rebrand — onboarding starts at /profiling/step-name.
// Re-add the import and the /get-started route below (plus point ONBOARDING_START back
// at "/get-started") to restore the intro screen.
// import GettingStartedV2Page from "@/features/onboarding/pages/getting-started-v2";
import DiagnosticPage from "@/features/onboarding/pages/diagnostic";
import LoginPage from "@/pages/login/login";
import RegisterPage from "@/pages/register/register";
import RegisterVerificationPage from "@/pages/register/register-verification";
import ResetPassword from "@/pages/reset-password/reset-password";
import ResetPasswordVerification from "@/pages/reset-password/reset-password-verification";
import RootRedirect from "@/pages/root-redirect";
import SplashScreen from "@/pages/splash-screen/splash-screen";
import PublicPrivacyPage from "@/pages/privacy-policy/public-privacy-page";
import PublicTermsPage from "@/pages/terms-and-conditions/public-terms-page";
import { RouteItem } from "./routes.type";

export const publicRoutes: readonly RouteItem[] = [
  {
    path: "/",
    exact: true,
    children: <RootRedirect />,
  },
  {
    path: "/splash-screen",
    children: <SplashScreen />,
  },
  // Disabled pending rebrand — see note on the GettingStartedV2Page import above.
  // {
  //   path: "/get-started",
  //   children: <GettingStartedV2Page />,
  // },
  {
    path: "/diagnostic",
    children: <DiagnosticPage />,
  },
  {
    path: "/login",
    children: <LoginPage />,
  },
  {
    path: "/reset-password",
    children: <ResetPassword />,
  },
  {
    path: "/reset-password-verification",
    children: <ResetPasswordVerification />,
  },
  {
    path: "/register",
    children: <RegisterPage />,
  },
  {
    path: "/register-verification",
    children: <RegisterVerificationPage />,
  },
  {
    path: "/delete-account",
    children: <PublicDeleteAccountPage />,
  },
  {
    path: "/terms-and-conditions",
    children: <PublicTermsPage />,
  },
  {
    path: "/privacy-policy",
    children: <PublicPrivacyPage />,
  },
] as const;
